import {AxiosResponse} from "axios";
import {BaseQueryOptions, BaseUseQueryResult, useBaseQuery} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {PAYMENT_FLOW_FEATURE_FLAGS_QUERY_KEY} from "../queryKeys";
import {PaymentFlowFeatureFlag} from "./types";

type Data = PaymentFlowFeatureFlag[];

const getPaymentFlowFeatureFlags = async (): Promise<Data> => {
  const response = await axiosReachInstance.get<Data, AxiosResponse<Data>>("/payment_flows/feature_flags");
  return response.data;
};

export const useGetPaymentFlowFeatureFlags = (options?: BaseQueryOptions<Data, void>): BaseUseQueryResult<Data> => {
  return useBaseQuery<Data, void>(
    [PAYMENT_FLOW_FEATURE_FLAGS_QUERY_KEY],
    getPaymentFlowFeatureFlags,
    undefined,
    options
  );
};
